import type { FC, PropsWithChildren } from "react";
import React, { useEffect } from "react";
import { type OAuthError, useAuth0 } from "@auth0/auth0-react";
import cube from "@cubejs-client/core";
import { CubeProvider as CubeClientProvider } from "@cubejs-client/react";
import logger from "@/helpers/logger";
import { promiseResolver } from "@/helpers/promise.helpers";

const apiUrl: string = import.meta.env.VITE_CUBE_API_URL;
const [tokenPromise, setToken] = promiseResolver<string>();

const cubeApi = cube(() => tokenPromise, { apiUrl });

/**
 * Wraps a provider for Cube.dev client if the env is supported.
 * Note: must be defined above the lazy routes
 */
const CubeProvider: FC<PropsWithChildren> = ({ children }) => {
  const { getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    getAccessTokenSilently()
      .then((token) => {
        setToken(token);
      })
      .catch((err: unknown) => {
        const { error_description, error } = err as OAuthError;
        logger.error(`Cube access error: ${error_description} (${error})`);
      });
  }, [getAccessTokenSilently]);

  return <CubeClientProvider cubeApi={cubeApi}>{children}</CubeClientProvider>;
};

export default CubeProvider;
